import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Grid, Paper, Box, Typography, makeStyles } from '@material-ui/core';
import CardWitTitle from './CardWithTitle';
import { statusCodes } from '../utilities/constants';

function ApplicationDecisions({ previousDecisions, ...props }) {

  useEffect(() => {
    // console.log(previousDecisions);
  }, []);

  const useStyles = makeStyles(theme => ({
    box: {
      textAlign: 'left',
      paddingTop: 20,
      paddingBottom: 20,
      borderTop: '1px solid #eee',
    },
    boxFirst: {
      paddingTop: 0,
      borderTop: 'none',
    }
  }));

  const classes = useStyles();

  const parseStatusCode = (code) => {
    switch (code) {
      case "400":
        return "Nekad";
      case "500":
        return "Komplettering krävs";
      case "600":
        return "Godkänd";
      default:
        return "";
    }
  }

  if (!previousDecisions) { return null; }
  
  return (
    <React.Fragment>
      <CardWitTitle title="Beslutslogg">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {Object.entries(previousDecisions).map(([key, value], index) => (
              <Box className={`${classes.box} ${index === 0 && classes.boxFirst}`} key={key}>
                <Typography variant='body2' style={{ fontWeight: 'bold' }}>
                  {`${parseStatusCode(value?.statusCode?.code)}`}
                </Typography>
                <Typography variant='body2'>{`${value?.timestamp?.toDate().toLocaleString()}`}</Typography>
                <Typography style={{ whiteSpace: 'pre-line' }}>{value?.feedbackFromAdmin?.trim()}</Typography>
              </Box>
            ))}
          </Grid>
        </Grid>

      </CardWitTitle>
    </React.Fragment>
  );
}

export default ApplicationDecisions;